"use client";

import React, { useEffect, useState } from "react";
import { Badge, Button, Card, Divider, Layout, Row, Col, Tabs, Table, Avatar, Typography, Rate, Image, Segmented, Tooltip, message, Tag } from "antd";
import { CalendarOutlined, DeleteOutlined, EditOutlined, EnvironmentOutlined, LeftOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import "./EventDetails.css";
import Event from "./Events.jsx";
import SuccessModal from "./SuccessModal.jsx";
import RejectionModal from "../Approval/RejectionModal.jsx";
import api from "../../../api";

const { Content } = Layout;
const { Title, Text } = Typography;

function EventDetailsPage() {
    const [eventData, setEventData] = useState(null);
    const [activeTab, setActiveTab] = useState("event");
    const [isEventModalVisible, setIsEventModalVisible] = useState(false);
    const [editEventData, setEditEventData] = useState(null);
    const [deleteSuccess, setDeleteSuccess] = useState(false);
    const [openRejectionModal, setOpenRejectionModal] = useState(false);
    const [eventCurrentData, setEventCurrentData] = useState(null);
    const [loading, setLoading] = useState(true)
    const [registrationData, setRegistrationData] = useState(null)
    const [messageApi, contextHolder] = message.useMessage();
    const location = useLocation();
    const selectedEventId = location.state.eventData.fld_event_id

    const navigate = useNavigate();

    useEffect(() => {
        if (location?.state?.eventData) {
            setEventData(location.state.eventData);
        }
    }, [location]);

    const getUserDetails = async () => {

        try {
            const requestData = {
                synceddatetime: "2025-05-29 10:08:00",
                FormCode: "201",
                AppVersion: "1.0.0.0",
                ApiKey: "kavin",
                AppTypeNo: "3",
            };
            const response = await api.getEventRegistrationDetails(requestData);

            if (response.data.status === "1") {
                const allData = response.data.events_data || [];

                // 🔥 Filter users based on event ID
                const filteredData = allData.filter(
                    (item) => item.fld_event_id == selectedEventId
                );


                setRegistrationData(filteredData);

            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }

    }


    useEffect(() => {
        getUserDetails()
    }, [])

    // Edit Event Handlers
    const handleEditEvent = () => {
        setIsEventModalVisible(true);
        setEditEventData(eventData);
    };

    const handleCloseEventModal = () => {
        setIsEventModalVisible(false);
        setEditEventData(null);
    };

    const handleEventSuccess = () => {
        // Refresh event data if needed
        if (location?.state?.eventData) {
            setEventData(location.state.eventData);
        }
        messageApi.success("Event updated successfully!");
    };

    // Delete Event Handlers
    const handleDeleteEvent = () => {
        setOpenRejectionModal(true);
        setEventCurrentData(eventData);
    };

    const handleDeleteApi = async (reason) => {
        try {
            if (eventCurrentData) {
                const requestData = {
                    "synceddatetime": "2025-05-29 10:08:00",
                    "FormCode": "201",
                    "AppVersion": "1.0.0.0",
                    "ApiKey": "kavin",
                    "AppTypeNo": "3",
                    "fld_rf_id": eventCurrentData?.fld_rf_id || "",
                    "fld_event_sw_id": eventCurrentData?.fld_event_sw_id,
                    "fld_reason_for_deletion": reason ? reason : ""
                };

                const response = await api.deleteEvent(requestData);

                if (response.data.status === "1") {
                    setDeleteSuccess(true);
                    setEventCurrentData(null);
                    setOpenRejectionModal(false);
                    messageApi.success("Event deleted successfully!");

                    // Navigate back to dashboard after successful deletion
                    setTimeout(() => {
                        navigate("/main/events");
                    }, 2000);
                }
            }
        } catch (error) {
            console.error("Error deleting event:", error);
            messageApi.error("Failed to delete event");
        }
    };

    const reviews = [
        {
            name: "John Davidson",
            initials: "JD",
            avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop",
            time: "2 days ago",
            rating: 5,
            comment: "Absolutely fantastic event! The organization was top-notch and the content was incredibly valuable. I learned so much about AI applications and got to network with amazing professionals in the field. Would definitely recommend this to anyone interested in AI.",
        },
        {
            name: "Sarah Martinez",
            initials: "SM",
            avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=400&fit=crop",
            time: "5 days ago",
            rating: 4,
            comment: "Great event overall. The speakers were knowledgeable and the venue was comfortable. My only minor critique would be that some sessions ran a bit long. Otherwise, it was an excellent experience and I gained valuable insights.",
        },
        {
            name: "Michael Kim",
            initials: "MK",
            avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop",
            time: "1 week ago",
            rating: 5,
            comment: "One of the best AI conferences I have attended. The practical workshops were particularly helpful, and I appreciated the hands-on approach. The networking opportunities were also excellent. Looking forward to the next one!",
        },
    ];

    const columns = [
        {
            title: 'Sl No',
            key: 'slNo',
            width: 80,
            render: (text, record, index) => index + 1,
        },
        {
            title: 'Company Name',
            dataIndex: 'fld_compny_press_name',
            key: 'companyName',
            width: 150,
        },
        // {
        //     title: 'Participant type',
        //     dataIndex: 'participantType',
        //     key: 'participantType',
        //     width: 140,
        //     render: (type) => (
        //         <span className="event-details-capitalize-text">{type}</span>
        //     ),
        // },
        {
            title: 'Phone',
            dataIndex: 'fld_contact_no',
            key: 'phone',
            width: 150,
        },
        {
            title: 'Registered Date',
            dataIndex: 'fld_registration_datetime',
            key: 'date',
            width: 100,
            render: (value) => value ? dayjs(value).format("DD MMM YYYY") : "-"
        },
        {
            title: 'Email id',
            dataIndex: 'fld_email',
            key: 'email',
            width: 180,
        },
        {
            title: 'Payment',
            dataIndex: 'fld_amount_paid',
            key: 'payment',
            width: 120,
            render: (payment) => {
                const hasDiscount = payment.includes('%');
                const discountMatch = payment.match(/(\d+)%off/);

                if (hasDiscount && discountMatch) {
                    const discount = discountMatch[1];
                    const amount = payment?.split(' ')[1];

                    return (
                        <span>
                            <span>{discount}%off</span>
                            <span> {amount}</span>
                        </span>
                    );
                }

                return <span>{payment}</span>;
            },
        },   //fld_checkin_status
        {
            title: 'Check In',
            dataIndex: 'fld_checkin_status',
            key: 'checkin',
            width: 180,
            render: (_, record) => {
                const endDate = location.state?.fld_end_date_time;
                const isEventCompleted = dayjs().isAfter(dayjs(endDate, "DD-MM-YYYY HH:mm:ss"));

                if (isEventCompleted && record.fld_checkin_status !== "IN") {
                    return <Tag color="red">Not Attended</Tag>;
                }

                if (record.fld_checkin_status === "IN") {
                    return <Tag color="green">Attended</Tag>;
                }

                return <Tag color="gold">Pending</Tag>;
            }
        }


    ];



    // Check if event is published (same logic as in EventDashboard)
    const isEventPublished = eventData?.fld_approved_name?.toLowerCase() === 'published';

    return (
        <div>
            {contextHolder}
            <div className="event-details-back-button-container">
                <Button
                    icon={<LeftOutlined />}
                    type="link"
                    onClick={() => navigate(-1)}
                    className="event-details-back-button"
                >
                    Back
                </Button>
            </div>

            <Layout className="event-details-page-container">
                <Content>
                    <div className="event-details-page-content">
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%" }}>
                            {/* Hero Section */}
                            <div className="event-details-hero-section">
                                <img
                                    className="event-details-hero-image"
                                    src={eventData?.fld_event_banner_path || ""}
                                    alt="Event background"
                                />
                                <div className="event-details-hero-content">
                                    <div className="event-details-hero-title-container">
                                        <h1 className="event-details-hero-title">
                                            {eventData?.fld_event_title || "AI meet"}
                                        </h1>
                                        <Badge
                                            count={eventData?.fld_tier_pricing_name}
                                            color="#000000ff"
                                            className="event-details-hero-badge"
                                        />
                                    </div>
                                    <div className="event-details-hero-date">
                                        {/* <CalendarOutlined className="event-details-hero-date-icon" /> */}
                                        <span className="event-details-hero-date-text">
                                            📅 {eventData?.fld_start_date_time
                                                ? dayjs(eventData.fld_start_date_time, "DD-MM-YYYY HH:mm:ss").format("DD-MMM-YYYY")
                                                : ""}
                                        </span>
                                    </div>
                                    <span className="event-details-hero-registration">
                                        Total Registration: {registrationData ? registrationData?.length : 0 }
                 ;                   </span>
                                </div>
                            </div>

                            {/* Main Content */}
                            <div className="event-details-main-content">
                                {/* Navigation Tabs */}
                                <div className="event-details-tabs-container">
                                    <Segmented
                                        options={[
                                            { label: "Event Details", value: "event" },
                                            { label: "Registered members", value: "registration" },
                                            // { label: "Reviews", value: "reviews" },
                                        ]}
                                        value={activeTab}
                                        onChange={setActiveTab}
                                        className="custom-segmented"
                                    />
                                </div>

                                <div className="event-details-tab-content-container" style={{ marginTop: activeTab !== "reviews" ? 24 : 0 }}>
                                    {activeTab === "event" && (
                                        <Card className="event-details-details-card" bodyStyle={{ padding: "32px" }}>
                                            <div className="event-details-details-section">
                                                {/* Event Description */}
                                                <div className="event-details-venue-container">
                                                    <h2 className="event-details-section-header">
                                                        Event Description
                                                    </h2>
                                                    <span className="event-details-section-description">
                                                        {eventData?.fld_event_description || "AI meeting"}
                                                    </span>
                                                </div>

                                                <Divider className="event-details-divider" />

                                                {eventData?.fld_terms_conditions && (
                                                    <>
                                                        <div className="event-details-venue-container">
                                                            <h2 className="event-details-section-header">
                                                                Terms & Conditions
                                                            </h2>
                                                            <div
                                                                style={{
                                                
                                                                    padding: "16px",
                                                               
                                                                    lineHeight: "1.8",
                                                                    color: "#555",
                                                                }}
                                                            >
                                                                {eventData.fld_terms_conditions}
                                                            </div>
                                                        </div>

                                                        <Divider className="event-details-divider" />
                                                    </>
                                                )}

                                                {/* Venue */}
                                                <Row gutter={[24, 16]} className="event-details-schedule-row">
                                                    <Col span={12}>
                                                        <div className="event-details-venue-container">
                                                            <h2 className="event-details-section-header">
                                                                {eventData?.fld_event_type_name.toLowerCase() === 'offline' ? 'Venue' : 'Meeting link'}
                                                            </h2>
                                                            <div className="event-details-venue-content">
                                                                {eventData?.fld_event_type_name.toLowerCase() === 'offline' ? <EnvironmentOutlined className="event-details-contact-icon" /> : '🎥'}
                                                                <span className="event-details-venue-text">
                                                                    {eventData?.fld_event_type_name.toLowerCase() === 'offline' ? eventData?.fld_venue : eventData?.fld_url}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    {eventData?.fld_event_type_name.toLowerCase() === 'offline' &&
                                                        <Col span={12}>
                                                            <div className="event-details-venue-container">
                                                                <h2 className="event-details-section-header">
                                                                    Venue Url
                                                                </h2>
                                                                <div className="event-details-venue-content">
                                                                    <EnvironmentOutlined className="event-details-contact-icon" />
                                                                    <span className="event-details-venue-text">
                                                                        {eventData?.fld_url}
                                                                    </span>
                                                                </div>
                                                            </div>

                                                        </Col>
                                                    }
                                                </Row>


                                                <Divider className="event-details-divider" />

                                                {/* Schedule */}
                                                <div className="event-details-schedule-container">
                                                    <h2 className="event-details-section-header">
                                                        Schedule
                                                    </h2>
                                                    <Row gutter={[24, 16]} className="event-details-schedule-row">
                                                        <Col span={12}>
                                                            <div className="event-details-schedule-item">
                                                                <span className="event-details-schedule-label">Start Date</span>
                                                                <span className="event-details-schedule-value">
                                                                    📅{eventData?.fld_start_date_time
                                                                        ? dayjs(eventData.fld_start_date_time, "DD-MM-YYYY HH:mm:ss").format("DD-MMM-YYYY")
                                                                        : ""}
                                                                </span>
                                                            </div>
                                                        </Col>

                                                        <Col span={12}>
                                                            <div className="event-details-schedule-item">
                                                                <span className="event-details-schedule-label">Start Time</span>
                                                                <span className="event-details-schedule-value">
                                                                    🕒{eventData?.fld_start_date_time
                                                                        ? dayjs(eventData.fld_start_date_time, "DD-MM-YYYY HH:mm:ss").format("hh:mm A")
                                                                        : ""}
                                                                </span>
                                                            </div>
                                                        </Col>

                                                        <Col span={12}>
                                                            <div className="event-details-schedule-item">
                                                                <span className="event-details-schedule-label">End Date</span>
                                                                <span className="event-details-schedule-value">
                                                                    📅{eventData?.fld_end_date_time
                                                                        ? dayjs(eventData.fld_end_date_time, "DD-MM-YYYY HH:mm:ss").format("DD-MMM-YYYY")
                                                                        : ""}
                                                                </span>
                                                            </div>
                                                        </Col>

                                                        <Col span={12}>
                                                            <div className="event-details-schedule-item">
                                                                <span className="event-details-schedule-label">End Time</span>
                                                                <span className="event-details-schedule-value">
                                                                    🕒{eventData?.fld_end_date_time
                                                                        ? dayjs(eventData.fld_end_date_time, "DD-MM-YYYY HH:mm:ss").format("hh:mm A")
                                                                        : ""}
                                                                </span>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                                <Divider className="event-details-divider" />

                                                <div className="event-details-schedule-container">
                                                    <h2 className="event-details-section-header">
                                                        Event Created date & time
                                                    </h2>
                                                    <Row gutter={[24, 16]} className="event-details-schedule-row">
                                                        <Col span={12}>
                                                            <div className="event-details-schedule-item">
                                                                <span className="event-details-schedule-label">Created Date</span>
                                                                <span className="event-details-schedule-value">
                                                                    📅{eventData?.fld_regiter_date_time
                                                                        ? dayjs(eventData.fld_regiter_date_time, "YYYY-MM-DD HH:mm:ss.SSSSS").format("DD-MMM-YYYY")
                                                                        : ""}
                                                                </span>
                                                            </div>
                                                        </Col>

                                                        <Col span={12}>
                                                            <div className="event-details-schedule-item">
                                                                <span className="event-details-schedule-label">Created Time</span>
                                                                <span className="event-details-schedule-value">
                                                                    🕒{eventData?.fld_regiter_date_time
                                                                        ? dayjs(eventData.fld_regiter_date_time, "YYYY-MM-DD HH:mm:ss.SSSSS").format("hh:mm A")
                                                                        : ""}
                                                                </span>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    {isEventPublished &&
                                                        <>
                                                            <h2 className="event-details-section-header">
                                                                Event Published date & time
                                                            </h2>
                                                            <Row gutter={[24, 16]} className="event-details-schedule-row">
                                                                <Col span={12}>
                                                                    <div className="event-details-schedule-item">
                                                                        <span className="event-details-schedule-label">Published Date</span>
                                                                        <span className="event-details-schedule-value">
                                                                            📅{eventData?.fld_approved_date_time
                                                                                ? dayjs(eventData.fld_approved_date_time, "YYYY-MM-DD HH:mm:ss").format("DD-MMM-YYYY")
                                                                                : ""}
                                                                        </span>
                                                                    </div>
                                                                </Col>

                                                                <Col span={12}>
                                                                    <div className="event-details-schedule-item">
                                                                        <span className="event-details-schedule-label">Published Time</span>
                                                                        <span className="event-details-schedule-value">
                                                                            🕒{eventData?.fld_approved_date_time
                                                                                ? dayjs(eventData.fld_approved_date_time, "YYYY-MM-DD HH:mm:ss").format("hh:mm A")
                                                                                : ""}
                                                                        </span>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </>
                                                    }

                                                </div>
                                                <Divider className="event-details-divider" />


                                                {/* Contact and Location Info */}
                                                <div className="event-details-contact-location-container">
                                                    <h2 className="event-details-section-header">Contact Information</h2>
                                                    <div className="event-details-contact-items">
                                                        {/* Phone */}
                                                        <div className="event-details-contact-item">
                                                            <span className="event-details-contact-icon">
                                                                📞
                                                            </span>
                                                            <span className="event-details-contact-text">
                                                                {eventData?.fld_contact_number || "N/A"}
                                                            </span>
                                                        </div>

                                                        {/* Email */}
                                                        <div className="event-details-contact-item">
                                                            <span className="event-details-contact-icon">
                                                                ✉️
                                                            </span>
                                                            <span className="event-details-contact-text">
                                                                {eventData?.fld_email_id || "N/A"}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    {/* Only show for offline events */}
                                                    {eventData?.fld_event_type_name?.toLowerCase() === "offline" && (
                                                        <>
                                                            <Divider />
                                                            <h2 className="event-details-section-header">Location Details</h2>

                                                            <div className="event-details-location-items">
                                                                <div className="event-details-contact-item">
                                                                    <EnvironmentOutlined className="event-details-contact-icon" />

                                                                    <span className="event-details-contact-text">
                                                                        {eventData?.fld_address || "N/A"},
                                                                        &nbsp;{eventData?.fld_city_name || "N/A"},
                                                                        &nbsp;{eventData?.fld_state_name || "N/A"}
                                                                    </span>
                                                                </div>
                                                            </div>

                                                        </>
                                                    )}
                                                </div>

                                                {eventData?.sponsors_data?.length > 0 && (
                                                    <div className="event-details-sponsors-container">
                                                        <h2 className="event-details-section-header">Our Sponsors</h2>
                                                        <div className="event-details-sponsors-grid">
                                                            {eventData.sponsors_data
                                                                .filter(
                                                                    (sponsor) =>
                                                                        sponsor?.fld_sponsors_name &&
                                                                        sponsor.fld_sponsors_name.trim() !== ""
                                                                )
                                                                .map((sponsor, index) => {
                                                                    const websiteUrl = sponsor.fld_website_url?.startsWith("http")
                                                                        ? sponsor.fld_website_url
                                                                        : `https://${sponsor.fld_website_url}`;

                                                                    return (
                                                                        <Tooltip
                                                                            key={index}
                                                                            title={websiteUrl}
                                                                            placement="top"
                                                                        >
                                                                            <a
                                                                                href={websiteUrl}
                                                                                target="_blank"
                                                                                rel="noopener noreferrer"
                                                                                className="event-details-sponsor-card-link"
                                                                            >
                                                                                <div className="event-details-sponsor-card">
                                                                                    <div className="event-details-sponsor-logo-wrapper">
                                                                                        <img
                                                                                            src={sponsor.fld_sponsors_loge}
                                                                                            alt={sponsor.fld_sponsors_name}
                                                                                        />
                                                                                    </div>
                                                                                    <span className="event-details-sponsor-name">
                                                                                        {sponsor.fld_sponsors_name}
                                                                                    </span>
                                                                                </div>
                                                                            </a>
                                                                        </Tooltip>
                                                                    );
                                                                })}
                                                        </div>
                                                    </div>
                                                )}

                                            </div>
                                        </Card>
                                    )}

                                    {activeTab === "registration" && (
                                        <div className="event-details-registration-container">
                                            <Table
                                                loading={loading}
                                                columns={columns}
                                                dataSource={registrationData}
                                                pagination={{
                                                    pageSizeOptions: ["5", "10", "25"],
                                                    showSizeChanger: true,
                                                    defaultPageSize: 5,
                                                    showTotal: (total, range) =>
                                                        `${range[0]}-${range[1]} of ${total} items`,
                                                }}
                                                bordered={false}
                                            />
                                        </div>
                                    )}
                                    {/* 
                                    {activeTab === "reviews" && (
                                        <div className="event-details-reviews-container">
                                            <div style={{ maxWidth: "100%", margin: "0 auto" }}>
                                                <div className="event-details-reviews-header">
                                                    <Title level={2}>Event Reviews</Title>
                                                    <Text type="secondary">See what attendees are saying about this event</Text>
                                                </div>

                                                <Row gutter={[0, 16]}>
                                                    {reviews.map((review, index) => (
                                                        <Col span={24} key={index}>
                                                            <Card className="event-details-review-card">
                                                                <div className="event-details-review-header">
                                                                    <Avatar src={review.avatar} className="event-details-review-avatar">
                                                                        {review.initials}
                                                                    </Avatar>
                                                                    <div className="event-details-review-info">
                                                                        <Text strong className="event-details-review-name">
                                                                            {review.name}
                                                                        </Text>
                                                                        <Text type="secondary" className="event-details-review-time">
                                                                            {review.time}
                                                                        </Text>
                                                                    </div>
                                                                    <Rate disabled defaultValue={review.rating} className="event-details-review-rating" />
                                                                </div>
                                                                <Divider />
                                                                <Text className="event-details-review-comment">{review.comment}</Text>
                                                            </Card>
                                                        </Col>
                                                    ))}
                                                </Row>
                                            </div>
                                        </div>
                                    )} */}
                                </div>

                                {/* Action Buttons */}
                                {isEventPublished ? " " :
                                    activeTab === "event" && (
                                        <Card
                                            className="event-details-action-buttons-card"
                                            bodyStyle={{
                                                padding: "16px 24px",
                                                display: "flex",
                                                justifyContent: "end",
                                                gap: "12px"
                                            }}
                                        >
                                            <Button
                                                danger
                                                size="medium"
                                                icon={<DeleteOutlined />}
                                                className="event-details-delete-button"
                                                onClick={handleDeleteEvent}
                                            >
                                                Delete
                                            </Button>
                                            <Button
                                                type="primary"
                                                size="medium"
                                                style={{ background: '#0072b1', padding: '0 20px' }}
                                                icon={<EditOutlined />}
                                                onClick={handleEditEvent}
                                            >
                                                Edit
                                            </Button>
                                        </Card>
                                    )
                                }

                            </div>
                        </div>
                    </div>
                </Content>
            </Layout>

            {/* Edit Event Modal */}
            {isEventModalVisible && (
                <Event
                    visible={isEventModalVisible}
                    onClose={handleCloseEventModal}
                    onSuccess={handleEventSuccess}
                    editdata={editEventData}
                    getEventData={handleEventSuccess}
                />
            )}

            {/* Delete Confirmation Modal */}
            {openRejectionModal && (
                <RejectionModal
                    title={'Delete Event'}
                    content={'Are you sure you want to Delete this Event? You cannot undo this change'}
                    buttonName='Delete'
                    open={openRejectionModal}
                    onClose={() => setOpenRejectionModal(false)}
                    onSubmit={(reason) => handleDeleteApi(reason)}
                />
            )}

            {/* Success Modal */}
            {deleteSuccess && (
                <SuccessModal
                    visible={deleteSuccess}
                    onClose={() => setDeleteSuccess(false)}
                    title={"Event Deleted Successfully"}
                    description="Your Event Has been Successfully Deleted!"
                />
            )}
        </div>
    );
}

export default EventDetailsPage;